import { defineStore } from "pinia";
import { ApiSup } from "@/Functions/ApiSupport";
import { useAuthStore } from '@/auth/auth'
import axios from 'axios'


export const useDbCountStore = defineStore('useDbCountStore',{
  state: () => ({
    studentCount: 0,
    studentDif: 0,

    eventsCount: 0,
    teacherCount: 0,
    teacherDif: 0,

    schoolCount: 0,
    schoolDif: 0,

    parentEngagement: 0,

    nonTeaching: 0,
    nonTeachingDif: 0

  }),
  actions:{
    async getStudentCount(userPID,schoolPID){
            const apiSup = ApiSup()
            // console.log('api/counts/studentCount/' + userPID + '/' + schoolPID)
            const ret = await apiSup.getSupport('api/counts/studentCount/' + userPID + '/' + schoolPID)

            this.studentCount = ret.count
            this.studentDif = ret.difference
            return ret

    },
    async getTeacherCount(userPID,schoolPID){
            const apiSup = ApiSup()
            // const ret = await apiSup.getSupport('api/counts/teacherCount/' + userPID + '/' + schoolPID)
            // this.teacherCount = ret.count
      const authStore = useAuthStore()


      const params = {
        schools: schoolPID
      }
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_HOST_API}/` + 'api/counts/teacherCount/' + userPID,
          {
            params: params,
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${authStore.token}`,
            }
          }
        )
      this.teacherCount = response.data.count
            this.teacherDif = response.data.difference

      } catch (error) {
        console.error('Error getTeacherCount:', error)
        throw error
      }

    },
    async getEventCount(userPID,schoolPID){
        const apiSup = ApiSup()
            // console.log('api/counts/studentCount/' + userPID + '/' + schoolPID)
            const ret = await apiSup.getSupport('api/counts/eventCount/' + userPID + '/' + schoolPID)

            this.eventsCount = ret.count


            // const apiSup = ApiSup()
            // const ret = await apiSup.getSupport('api/counts/eventCount/' + userPID + '/' + schoolPID)
            // this.eventsCount = ret.count


      //   const authStore = useAuthStore()


      // const params = {
      //   schools: schoolPID
      // }
      // try {
      //   const response = await axios.get(
      //     `${import.meta.env.VITE_HOST_API}/` + 'api/counts/eventCount/' + userPID,
      //     {
      //       params: params,
      //       headers: {
      //         'Content-Type': 'application/json',
      //         Authorization: `Bearer ${authStore.token}`,
      //       }
      //     }
      //   )
      // this.eventsCount = response.data.count
      // console.log(this.eventsCount)

      // } catch (error) {
      //   console.error('Error getTeacherCount:', error)
      //   throw error
      // }
    },
    async getNonTeachingCount(userPID,schoolPID){
            const apiSup = ApiSup()
            // const ret = await apiSup.getSupport('api/counts/nonTeachingCount/' + userPID + '/' + schoolPID)
            // this.nonTeaching = ret.count


        const authStore = useAuthStore()


      const params = {
        schools: schoolPID
      }
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_HOST_API}/` + 'api/counts/nonTeachingCount/' + userPID,
          {
            params: params,
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${authStore.token}`,
            }
          }
        )
      this.nonTeaching = response.data.count

            this.nonTeachingDif = response.data.difference

      } catch (error) {
        console.error('Error getTeacherCount:', error)
        throw error
      }
    },
    async getSchoolCount(userPID,schoolPID){
            const apiSup = ApiSup()
            // const ret = await apiSup.getSupport('api/counts/getSchools/' + userPID + '/' + schoolPID)
            // this.schoolCount = ret.count


        const authStore = useAuthStore()


      const params = {
        schools: schoolPID
      }
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_HOST_API}/` + 'api/counts/getSchools/' + userPID,
          {
            params: params,
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${authStore.token}`,
            }
          }
        )
      this.schoolCount = response.data.count
            this.schoolDif = response.data.difference

      } catch (error) {
        console.error('Error getTeacherCount:', error)
        throw error
      }
    },
    async getParentEngagement(userPID,schoolPID){
            const apiSup = ApiSup()
            // const ret = await apiSup.getSupport('api/counts/parentEngagement/' + userPID + '/' + schoolPID)
            // this.parentEngagement = ret.count


        const authStore = useAuthStore()


      const params = {
        schools: schoolPID
      }
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_HOST_API}/` + 'api/counts/parentEngagement/' + userPID,
          {
            params: params,
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${authStore.token}`,
            }
          }
        )
      this.parentEngagement = response.data.count

      } catch (error) {
        console.error('Error getTeacherCount:', error)
        throw error
      }
    },
  }
})
